export const calculateProyectanteExterior = (width, height) => {
  const verticalElements = {
    'Marco': Math.floor(height + 5),
    'Refuerzo Marco': Math.floor(height - 126),
    'Hoja Exterior': Math.floor(height - 55),
    'Refuerzo Hoja Exterior': Math.floor(height - 222),
    'Junquillo': Math.floor(height - 176),
  };

  const horizontalElements = {
    'Marco': Math.floor(width + 5),
    'Refuerzo Marco': Math.floor(width - 126),
    'Hoja Exterior': Math.floor(width - 55),
    'Refuerzo Hoja Exterior': Math.floor(width - 222),
    'Junquillo': Math.floor(width - 176),
  };

  const barrasNecesarias = {};
  const largoBarra = 6000; // mm

  // Calcular barras para elementos verticales
  for (const [perfil, largo] of Object.entries(verticalElements)) {
    const cantidadPiezas = 2;
    const piezasVerticales = Array(cantidadPiezas).fill(largo);
    
    barrasNecesarias[perfil] = {
      cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
      desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
      piezasVerticales,
      piezasHorizontales: [],
      largoTotal: largo * cantidadPiezas
    };
  }

  // Calcular barras para elementos horizontales y combinar con verticales
  for (const [perfil, largo] of Object.entries(horizontalElements)) {
    const cantidadPiezas = 2;
    const piezasHorizontales = Array(cantidadPiezas).fill(largo);
    
    if (!barrasNecesarias[perfil]) {
      barrasNecesarias[perfil] = {
        cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
        desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
        piezasVerticales: [],
        piezasHorizontales,
        largoTotal: largo * cantidadPiezas
      };
    } else {
      const largoTotalCombinado = (largo * cantidadPiezas) + barrasNecesarias[perfil].largoTotal;
      barrasNecesarias[perfil] = {
        ...barrasNecesarias[perfil],
        cantidadBarras: Math.ceil(largoTotalCombinado / largoBarra),
        desperdicioMm: (Math.ceil(largoTotalCombinado / largoBarra) * largoBarra) - largoTotalCombinado,
        piezasHorizontales,
        largoTotal: largoTotalCombinado
      };
    }
  }

  return {
    vertical: verticalElements,
    horizontal: horizontalElements,
    barrasNecesarias,
    type: 'Proyectante Exterior',
    photo: "/fotos/proyectante.jpg",
  };
};

export const calculateVidriosProyectanteExterior = (height, width) => {
  const vidrioHeight = Math.floor(height - 184);
  const vidrioWidth = Math.floor(width - 184);

  return { 
    vertical: Math.max(0, vidrioHeight), 
    horizontal: Math.max(0, vidrioWidth) 
  };
};
